import React, { useEffect, useState } from 'react';

import { CustomResponsiveTable } from '../../components/common/SimpleResponsiveTable';
import { Empty, notification, Tag } from 'antd';
import { IParts, OrderLineItemProps } from '../../types/types';
import { useHistory } from 'react-router';
import SalesOrderStore from '../../stores/SalesOrderStore';
import { ErrorRender } from '@partsbadger/library';
import dayjs from 'dayjs';

interface IPartHistory {
    master_product_id: number;
    part_data: IParts | undefined;
}

interface IParams {
    master_product: number;
}

export default function OrdersHistory({ master_product_id, part_data }: IPartHistory) {
    const [data, setData] = useState<OrderLineItemProps[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const history = useHistory();

    async function fetch() {
        setLoading(true);

        const params: IParams = {
            master_product: master_product_id,
            // page: 1,
            // hide_draft_orders: true,
        };

        try {
            const response = await SalesOrderStore.getSalesOrderLineItems(params);
            setData(response.results);
            setLoading(false);
        } catch (err: any) {
            notification.error({
                duration: 10,
                message: 'Error',
                description: <ErrorRender error={err} />,
                placement: 'bottomRight',
            });
            setLoading(false);
        }
    }

    useEffect(() => {
        fetch();
    }, []);

    const emptyTable = () => {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<span style={{ color: '#000' }}>This part doesn't have orders.</span>}
            />
        );
    };

    return (
        <>
            <CustomResponsiveTable
                columns={[
                    {
                        title: 'Sales Order',
                        dataIndex: 'sales_order.name',
                        width: 100,
                        render: (_, record: OrderLineItemProps) => {
                            return (
                                <div>
                                    <div>{record.sales_order.name}</div>
                                    {record.sales_order.completed ? (
                                        <Tag color="green">Completed</Tag>
                                    ) : (
                                        <Tag>{record.sales_order.customer_status}</Tag>
                                    )}
                                </div>
                            );
                        },
                    },
                    {
                        title: 'Date',
                        dataIndex: 'created_time',
                        width: 110,
                        render: (text, record) => {
                            return (
                                <div>
                                    <div>{dayjs(record.created_time).format('YYYY-MM-DD')}</div>
                                    <div className={'italic'}>By {record.contact_related?.fullname}</div>
                                </div>
                            );
                        },
                    },
                    {
                        title: 'Purchase Order',
                        dataIndex: 'sales_order.purchase_order',
                        width: 100,
                    },
                    {
                        title: 'Qty',
                        dataIndex: 'quantity',
                        width: 100,
                    },
                    {
                        title: 'Est Ship Date',
                        dataIndex: 'required_part_ship_date',
                        width: 100,
                        render: (text, record) => {
                            return <div>{record.required_part_ship_date}</div>;
                        },
                    },
                ]}
                loading={loading}
                data={data}
                pagination={false}
                rowClassName={() => {
                    return 'cursor-pointer';
                }}
                onRow={record => {
                    return {
                        onClick: () => {
                            history.push('/my-account/orders/' + record.sales_order.id);
                        },
                    };
                }}
                emptyTable={emptyTable}
            />
        </>
    );
}
